// Generated types for DerivedValue
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from '../../shared/types/scopednode';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from '../../shared/types/scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface DerivedValueReadAPI extends ScopedNodeReadAPI {
  /** The computed value (written by the expression's evaluation, never by a caller). */
  value?: unknown | null;
  /** When the value was last computed (ISO timestamp). */
  evaluated_at?: string | null;
  /** Computed field: calculation_status */
  readonly calculation_status?: string | null;
  /** Computed field: calculation_error */
  readonly calculation_error?: string | null;
  /** Computed field: calculation_message */
  readonly calculation_message?: string | null;
  /** Computed field: calculation_request_id */
  readonly calculation_request_id?: string | null;
}

export interface DerivedValueWriteAPI extends ScopedNodeWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const DerivedValueReadAPISchema: z.ZodType<DerivedValueReadAPI> = ScopedNodeReadAPISchemaObject.extend({
  value: z.unknown().nullable().optional(),
  evaluated_at: z.string().nullable().optional(),
  calculation_status: z.string().nullable().optional(),
  calculation_error: z.string().nullable().optional(),
  calculation_message: z.string().nullable().optional(),
  calculation_request_id: z.string().nullable().optional(),
}).passthrough();

export const DerivedValueWriteAPISchema: z.ZodType<DerivedValueWriteAPI> = ScopedNodeWriteAPISchemaObject.extend({}).passthrough();
